import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-add-program-type',
  templateUrl: './add-program-type.component.html'
})
export class AddProgramTypeComponent implements OnInit {

  addProgramForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  IsFree: any;
  
  constructor(public service: MainService, private router: Router) { }

  ngOnInit() {
    this.addProgramFormValidation();
  }

  // Add Subadmin Form Validation

  addProgramFormValidation() {
    this.addProgramForm = new FormGroup({
      'title': new FormControl('', Validators.compose([Validators.required])),
     });

  }
 


  
  // Add Program Api Integration 

  addProgram() {
    const data = {
      programType: this.addProgramForm.value.title,
     

    }
    this.service.showSpinner()
    this.service.postApi(ApiUrls.programType_add, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage)
        this.router.navigate(['/program-type-mgt'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }


}
